export default {
  sanity: {
    projectId: '66qkaub2',
    dataset: 'production'
  }
}
